import { useContext, useState, useEffect } from "react";
import { GridContext } from "src/context/GridContext/GridContext";
import {
  Button,
  Dialog,
  Menu,
  MenuItem,
  Paper,
  Tab,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import StepButtons from "src/components/buttons/StepButtons/StepButtons";
import GridVehicleSelectorDropDown from "../GridVehicleSelectorDropdown";
import { StaticDatePicker, TimePicker } from "@mui/x-date-pickers";
import { pvmString } from "src/components/js/statics1";
import { PalkkiIcon } from "src/components/icons/PalkkiIcons";
import { DropdownIcon } from "src/components/icons/ArrowIcons";
import gridPalkkiClass from "src/data/gridPalkki/gridPalkkiClass";
import { useUserData } from "src/context/userContext";
import MyTabs from "src/components/layout/MyTabs/MyTabs";
import { TabPanel, a11yProps } from "src/components/js/Statics";
import GridPalkkiEditor_VisibilityTab from "./components/GridPalkkiEditor_VisibilityTab";
import { addMinutes } from "date-fns";

const styles = {
  timePicker: {
    width: "125px",
  },
};

export default function GridPalkkiEditor() {
  const { token, socket, auth, user } = useUserData();
  const {
    vehicleLookup,
    setGridPalkkiEditorIsOpen,
    gridPalkki: palkki,
    setGridPalkki,
    palkkiTypes,
    setKeikka,
  } = useContext(GridContext) || {};
  const [comment, setComment] = useState(palkki?.keikkaComment || "");
  const [vehicle, setVehicleState] = useState(null);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    setComment(palkki?.keikkaComment || "");
    setVehicle(palkki?.vehicleId > 0 ? vehicleLookup[palkki.vehicleId] : null);
  }, [palkki]);

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const setVehicle = (vehicle) => {
    setVehicleState(vehicle);
    if (palkki === null) return;
    palkki.vehicleId = vehicle?.vehicleId;
    setKeikka(palkki);
  };
  const handleOpenMenu = (event) => {
    if (!auth.action.palkki.create) return;
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenDatePicker = () => {
    if (auth.action.palkki.create) setShowDatePicker(true);
  };

  const handleCloseDatePicker = (s) => {
    // check if s is a date
    if (s instanceof Date) {
      palkki.timeStart = s;
      palkki.timeEnd = addMinutes(s, palkki.pumppuKesto);
      setKeikka(palkki);
    }
    setShowDatePicker(false);
  };
  const handleCommentChange = (event) => {
    if (auth.action.palkki.create) setComment(event.target.value);
  };
  const handleCancelKlik = () => {
    setGridPalkkiEditorIsOpen(false);
    setGridPalkki(null);
  };
  const handleSaveKlik = async () => {
    palkki.keikkaComment = comment;
    setKeikka(palkki);
    setGridPalkkiEditorIsOpen(false);
    setGridPalkki(null);
    const a = await gridPalkkiClass.saveToDbStatic(palkki, token, socket, user.personId);
    return a;
  };
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 12,
        paddingTop: "15px",
        width: "100%",
      }}>
      {renderTopBar()}
      <Paper>
        {auth.action.palkki.create && (
          <MyTabs value={tabValue} onChange={handleTabChange}>
            <Tab key={0} label="Palkki" {...a11yProps(0)} />
            <Tab key={1} label="Oikeudet" {...a11yProps(1)} />
          </MyTabs>
        )}
        <TabPanel value={tabValue} index={0} sx={{ minHeight: "200px" }}>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "flex-start",
              minHeight: "150px",
              padding: "10px",
            }}>
            <TextField
              value={comment}
              onChange={handleCommentChange}
              label={palkki?.grid_palkkiType}
              multiline
              fullWidth
            />
          </div>
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <div style={{ minHeight: "150px", padding: "10px" }}>
            <GridPalkkiEditor_VisibilityTab palkki={palkki} />
          </div>
        </TabPanel>
      </Paper>
      <div className="palkkiModal">
        <StepButtons
          size="small"
          onCancelKlik={auth.action.palkki.create ? handleCancelKlik : undefined}
          onSaveKlik={auth.action.palkki.create ? handleSaveKlik : undefined}
          onCloseKlik={!auth.action.palkki.create ? handleCancelKlik : undefined}
        />
      </div>
    </div>
  );

  function renderTopBar() {
    return (
      <div className="spaceBetween" style={{ flexWrap: "wrap", gap: 3 }}>
        <div style={{ display: "flex", flex: 30, gap: 3 }}>
          <div>
            <Button
              variant="outlined"
              onClick={handleOpenDatePicker}
              sx={{ height: "55px", fontSize: "1.1rem" }}>
              {pvmString(palkki?.timeStart)}
            </Button>
          </div>
          <div style={{ minWidth: "175px", flex: 1 }}>
            <GridVehicleSelectorDropDown
              vehicle={vehicle}
              setVehicle={setVehicle}
              disabled={!auth.action.palkki.create}
              fontSize="1.0rem"
              height="55px"
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: 4,
            flexGrow: 1,
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}>
          <div style={{ display: "flex", gap: 4 }}>
            <TimePicker
              sx={styles.timePicker}
              label="Aloitus"
              value={palkki?.timeStart || new Date()}
              onChange={(value) => {
                palkki.timeStart = value;
                palkki.pumppuKesto = (palkki.timeEnd - palkki.timeStart) / 60000;
                setKeikka(palkki);
              }}
              disabled={!auth.action.palkki.create}
            />
            <TimePicker
              sx={styles.timePicker}
              fullWidth
              label="Lopetus"
              value={palkki?.timeEnd || new Date()}
              onChange={(value) => {
                palkki.timeEnd = value;
                palkki.pumppuKesto = (palkki.timeEnd - palkki.timeStart) / 60000;
                setKeikka(palkki);
              }}
              disabled={!auth.action.palkki.create}
            />
          </div>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
            {palkkiTypes?.map((type) => (
              <MenuItem
                key={type.grid_palkkiTypeId}
                onClick={() => {
                  palkki.grid_palkkiType = type.grid_palkkiType;
                  palkki.grid_palkkiTypeDescription = type.grid_palkkiTypeDescription;
                  palkki.grid_palkkiTypeId = type.grid_palkkiTypeId;
                  setKeikka(palkki);
                  handleCloseMenu();
                }}>
                <PalkkiIcon palkki={{ grid_palkkiTypeId: type.grid_palkkiTypeId }} />
                <Typography color="primary" variant="body">
                  {type.grid_palkkiType}
                </Typography>
              </MenuItem>
            ))}
          </Menu>
          <div>
            <Tooltip title={palkki?.grid_palkkiType} placement="top" disableInteractive>
              <Button
                variant="outlined"
                sx={{ height: "55px", minWidth: "75px" }}
                onClick={handleOpenMenu}>
                <PalkkiIcon palkki={palkki} />
                <DropdownIcon />
              </Button>
            </Tooltip>
          </div>
        </div>
        {showDatePicker && (
          <Dialog open={showDatePicker}>
            <StaticDatePicker
              sx={{ width: "150px", minWidth: "150px" }}
              variant="standard"
              value={palkki?.timeStart}
              onChange={handleCloseDatePicker}
              onClose={handleCloseDatePicker}
              disabled={!auth.action.palkki.create}
            />
          </Dialog>
        )}
      </div>
    );
  }
}
